import { useCallbackRef } from "@opensea/ui-kit/hooks"
import type { Nullable } from "@opensea/utils"
import { createContext, type RefObject, useContext } from "react"

type ElementType = HTMLElement

type AutoScrollContainerContextType = {
  available: boolean

  ref: Nullable<RefObject<Nullable<ElementType>>>
  setRef: (node: Nullable<ElementType>) => void
}

const AutoScrollContainerContext =
  createContext<AutoScrollContainerContextType>({
    available: false,
    ref: null,
    setRef: () => false,
  })

type Props = {
  children: React.ReactNode
}

export function AutoScrollContainerProvider({ children }: Props) {
  const [ref, setRefCallback] = useCallbackRef<HTMLElement>()

  function setRef(node: Nullable<ElementType>) {
    if (!node) {
      return
    }

    setRefCallback(node)
  }

  const value = { available: true, ref, setRef }

  return (
    <AutoScrollContainerContext.Provider value={value}>
      {children}
    </AutoScrollContainerContext.Provider>
  )
}

export function useAutoScrollContainer() {
  return useContext(AutoScrollContainerContext)
}
